        gsap.set(".logo-stick-in", { yPercent: 200, paddingTop: "10%" });
        setTimeout(() => {
          $(".logo-stick-in").removeClass('loading');
        }, 1000);
        document.addEventListener("DOMContentLoaded", (event) => {
          setTimeout(() => {
            const lenis = new Lenis({
              duration: 1.2,
              easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
            });
        
            function raf(time) {
              lenis.raf(time);
              requestAnimationFrame(raf);
            }
            requestAnimationFrame(raf);
        
            gsap.registerPlugin(ScrollTrigger);
        
        
            ScrollTrigger.scrollerProxy(document.documentElement, {
              scrollTop(value) {
                return arguments.length
                  ? lenis.scrollTo(value, {immediate: true})
                  : lenis.scroll;
              },
              getBoundingClientRect() {
                return {top: 0, left: 0, width: window.innerWidth, height: window.innerHeight};
              },
              pinType: document.documentElement.style.transform
                ? 'transform'
                : 'fixed'
            });
        setTimeout(() => {
          gsap.to(".logo-stick-in", 
            { yPercent: 120, paddingTop: "25%", opacity: 1, duration: 0.8, ease: "power2.out", delay: 0.4, 
              onComplete: () => {
                // Step 2: now enable your scrollTrigger timeline
                initLogoScroll();
              }
            }
          );
        }, 2000);
        // Header Logo Animation
        function initLogoScroll() {
          const tl = gsap.timeline({
              scrollTrigger: {
                trigger: ".home-banner",
                start: "top top",
                end: "+=50%",
                scrub: true,
                onUpdate: self => {
                  if (self.progress >= 0.90) {
                    gsap.to(".logo-stick-in svg path", {
                      fill: "#4B3A36",
                      overwrite: true,
                      duration: 0
                    });
                  } else {
                    gsap.to(".logo-stick-in svg path", {
                      fill: "#fff",
                      overwrite: true,
                      duration: 0
                    });
                  }
                },
                onRefresh: self => {
                  if (self.progress === 1) {
                    tl.progress(1); 
                  }
                }
              }
            });
            tl.fromTo(".logo-stick-in", {
              yPercent: 120
            }, {
              yPercent: 0,
              ease: "none",
              duration: 1
            });
            tl.fromTo(".logo-stick-in", {
              scale: 1
            }, {
              scale: 0.08,
              ease: "none",
              duration: 1
            }, 0);
        }
        
        // Header Scroll Backdrop
            let removeTimer;
            let allowHover = true;
            const $logo = $('.logo-stick');
            const $logo_center = $('.header-in .center');
            const $trigger = $('.has-mega-menu');
            const header = document.querySelector('header');
        
            lenis.on('scroll', ({scroll, limit}) => {
              const scrollPercentage = (scroll / limit) * 100;
              allowHover = scrollPercentage <= 5;
        
        // header backdrop logic
              if (scrollPercentage > 5) {
                header.classList.add('backdrop');
        
        // force‐close menu if you scrolled past 5%
        
                clearTimeout(removeTimer);
                $logo.removeClass('mega-menu-open');
                $logo_center.removeClass('mega-menu-open');
              } else {
                header.classList.remove('backdrop');
              }
            });
        
            $trigger.hover(function() {
              if (! allowHover) 
                return;
              
        
        
        
              clearTimeout(removeTimer);
              $logo.addClass('mega-menu-open');
              $logo_center.addClass('mega-menu-open');
              lenis.stop();
            }, function() {
              if (! allowHover) 
                return;
              
        
        
        
              removeTimer = setTimeout(() => {
                $logo.removeClass('mega-menu-open');
                $logo_center.removeClass('mega-menu-open');
                lenis.start();
              }, 300);
            });
        
            $(".nav-item.has-mega-menu").hover(function() {
              lenis.stop();
            }, function() {
              lenis.start();
            });
        
        
            $(document).on("click", ".cart-open", function() {
              console.log("Cart open clicked");
              $(".my-cart").addClass("active");
              $("body").addClass("js-show-ajax-cart");
              $(".cart-backdrop").addClass("active");
              lenis.stop();
            });
        
            $(document).on("click", ".cart_close", function() {
              console.log("Cart close clicked");
              $(".my-cart").removeClass("active");
              $("body").removeClass("js-show-ajax-cart");
              $(".cart-backdrop").removeClass("active");
              lenis.start();
            });
            $(document).on("click", ".cart-backdrop", function() {
              $(".my-cart").removeClass("active");
              $("body").removeClass("js-show-ajax-cart");
              $(".cart-backdrop").removeClass("active");
            });
        
            gsap.registerPlugin(SplitText);
        
            // Function to initialize the animation for each element
            function initializeAnimation(target) {
              if (target) {
                var tl = gsap.timeline({
                  paused: true, // Pause the timeline initially
                });
                var mySplitText = new SplitText(target, { type: "words,chars" }),
                  chars = mySplitText.chars; // An array of all the divs that wrap each character
        
                // Hide the target initially (opacity 0 and visibility hidden)
                gsap.set(target, { autoAlpha: 0 });
        
                // Set perspective for 3D effect
                gsap.set(target, { perspective: 400 });
        
                // Define the animation
                tl.to(target, { autoAlpha: 1, duration: 0 }); // Make the target visible at the start (opacity 0 -> 1)
                tl.from(chars, {
                  duration: 1,
                  opacity: 0,
                  rotationY: 115,
                  transformOrigin: "100% 0% 0",
                  stagger: 0.03,
                });
        
                tl.restart(); // Trigger the animation
              }
            }
        
            // Intersection Observer to check if any .letter-animation element is in view
            const observer = new IntersectionObserver(
              (entries, observer) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    initializeAnimation(entry.target); // Initialize the animation for each element
                    observer.unobserve(entry.target); // Stop observing after initialization
                  }
                });
              },
              { threshold: 0.5 } // Trigger when 50% of the element is visible
            );
        
            // Get all elements with the class 'letter-animation' (or use any other selector)
            const target_banner = document.querySelectorAll(".letter-animation-banner");
            const targets = document.querySelectorAll(".letter-animation");
            if (target_banner.length) {
                setTimeout(() => {
                    target_banner.forEach((target) => {
                        observer.observe(target);
                    });
                }, 3500); // delay in ms
            }
            if (targets.length) {
                targets.forEach((target) => {
                    observer.observe(target);
                });
            }
        
        
            const mm = gsap.matchMedia();
            mm.add("(min-width: 992px)", () => {
              const imgEls = document.querySelectorAll('.animate-img');
              imgEls.forEach(img => {
                gsap.fromTo(img, {
                  y: -50
                }, {
                  y: 50,
                  ease: 'none',
                  scrollTrigger: {
                    trigger: img,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true
                  }
                });
              });
        
              const lessboxEls = document.querySelectorAll('.animate-box-less');
              lessboxEls.forEach(lessbox => {
                gsap.fromTo(lessbox, {
                  y: 20
                }, {
                  y: -20,
                  ease: 'none',
                  scrollTrigger: {
                    trigger: lessbox,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true
                  }
                });
              });
        
              const boxEls = document.querySelectorAll('.animate-box');
              boxEls.forEach(box => {
                gsap.fromTo(box, {
                  y: 50
                }, {
                  y: -50,
                  ease: 'none',
                  scrollTrigger: {
                    trigger: box,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true
                  }
                });
              });
        
              const moreboxEls = document.querySelectorAll('.animate-box-more');
              moreboxEls.forEach(morebox => {
                gsap.fromTo(morebox, {
                  y: 100
                }, {
                  y: -200,
                  ease: 'none',
                  scrollTrigger: {
                    trigger: morebox,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true
                  }
                });
              });
        
        // optional cleanup when this media query no longer matches
              return() => {
                ScrollTrigger.getAll().forEach(st => st.kill());
              };
            });
            $(".header-icons-wrap .search, .mobile_header .search").click(function(e) {
              e.preventDefault();
              $(".search-bar").toggleClass("active");
              if ($(".search-bar").hasClass("active")) {
                lenis.stop();
              } else {
                lenis.start();
              }
            });
            $(document).keyup(function(e) {
              if (e.key === "Escape") {
                $(".search-bar").removeClass("active");
                lenis.start();
              }
            });
        
            ScrollTrigger.refresh();
        
          }, 0);
        });